import React from 'react'
import { useState,useEffect } from 'react'
import "../index.css";
import Home from './home';
import PageNotFound from './pageNotFound';
import Dashboard from './dashboard';
import UserToken from './userToken';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
  Outlet,
  useParams,
  NavLink,
  useNavigate,
  useLocation
  
  
  } from 'react-router-dom';
  import CustomReportMain from './cstmRptMain'
function Login() {
      return (
        <Router>      
           <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/dashboard' element={<Dashboard />}/>
              <Route path='*' element={<PageNotFound />}/>
              <Route path='/userToken' element={<UserToken/>}/>
              <Route path='/cstmRptMain' element={<CustomReportMain/>}/>
            </Routes>    
        </Router>     
      );
  
   
  }

export default Login
